import React, { Component } from 'react'
import {
    Button, Container
} from 'reactstrap'
/* import { AnimateOnChange } from 'react-animation' */
import Productos from '../productos'
import BuscarProductos from '../productos/buscar'
import { Icon } from 'react-icons-kit'
import { ic_keyboard_arrow_up } from 'react-icons-kit/md/ic_keyboard_arrow_up'
import Slider from '../slider'
import Logo from '../images/LOGO.jpeg'
import './main.css'
import ReactPixel from 'react-facebook-pixel'


export default class Principal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingProductos: true,
            btnScroll: false,
            search: ''
        }

        this.handleScroll = this.handleScroll.bind(this)
        this.onChangeSearch = this.onChangeSearch.bind(this)
        this.buscarProducto = this.buscarProducto.bind(this)
    }

    onChangeSearch(search = '') {
        this.setState({
            search
        })
    }

    buscarProducto(e) {
        e.preventDefault()
        if (this.state.search !== '') {
            ReactPixel.fbq('track', 'Search')
            this.props.history.push(`/productos/search/${this.state.search}`)
        }
    }

    scrollToTop() {
        var scrollStep = -window.scrollY / (400 / 15),
            scrollInterval = setInterval(function () {
                if (window.scrollY !== 0) {
                    window.scrollBy(0, scrollStep);
                }
                else clearInterval(scrollInterval);
            }, 15)
    }

    handleScroll(event) {
        if (window.scrollY > 550) {
            this.setState({
                btnScroll: true
            })
        } else {
            this.setState({
                btnScroll: false
            })
        }
    }



    componentDidMount() {
        window.scrollTo(0, 0)
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    render() {
        return (
            <div className="menuContainer">
                {/* <div className="LogoEmpresa">
                    <img src={Logo} />
                </div> */}
                <Slider />

                {/* <Container >
                    <BuscarProductos onChangeSearch={this.onChangeSearch} buscarProducto={this.buscarProducto} />
                </Container> */}
                <div className="d-flex justify-content-center">
                    <h2 className="products-title">Iluminando tus ideas</h2>
                </div>
                
                <Productos />
                {
                    this.state.btnScroll &&
                    <Button color="warning" className="botonRedondo" onClick={this.scrollToTop}>
                        <Icon size={30} icon={ic_keyboard_arrow_up} />
                    </Button>
                }
            </div>
        )
    }

}